import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const DataContainer = styled.div(({ theme }) => ({
    display: "grid",
    alignItems: "center",
    gap: `${theme.spacing.small}`,
    "& input": {
        borderRadius: theme.spacing.medium,
    },
}));

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow: "hidden";
`;

export const Title = styled(Text)(({ theme }) => ({
    marginLeft: `${theme.spacing.xSmall}`,
    marginBottom: `${theme.spacing.xSmall}`,
}));

export const CtaContainer = styled.div(({ theme }) => ({
    marginTop: `${theme.spacing.medium}`,
}));

export const EmptyResultsText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.medium,
    marginLeft: theme.spacing.large,
}));

export const Footer = styled.div(({ theme }) => ({
    display: "grid",
    gap: `${theme.spacing.medium}`,
    marginBottom: `${theme.spacing.xLarge}`,
    "@supports (margin-bottom: var(--sab))": {
        paddingBottom: "var(--sab)",
    },
    position: "sticky",
}));

export const SuccessContainer = styled.div(({ theme }) => ({
    display: "grid",
    gridAutoFlow: "column",
    gap: `${theme.spacing.small}`,
    alignItems: "center",
    justifyContent: "center",
}));

export const IconContainer = styled.div(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const TimerContainer = styled.div(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const DescriptionContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing.xxSmall,
}));

export const InfoIconContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: theme.spacing.medium,
}));

export const FieldRenderer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.medium,
    maxHeight: "60vh",
    overflowY: "auto",
    paddingBlock: theme.spacing.xxSmall,
}));
